export default __webpack_public_path__ + "static/media/calculation.3a346216.png";